import * as React from 'react';
import * as _ from 'lodash';
import { RadioOptions, RadioOption, LabelRadio, ButtonRadioContainer } from './styles';
import { LabelMessage } from './styles';
import { cancel } from 'redux-saga/effects';
import RadioButtonIcon, { IRadioButtonProps } from 'common/icons/radioButtonIcon';
import { AnyObject } from 'chart.js/types/basic';
import { CSSProperties } from 'styled-components';

export interface RadioButtonListItem {
    id: string;
    name: string;
    enable?: boolean;
    itemMessage?: string;
    
}

export interface RadioButtonListProps {
    name?: string;
    RadioButtonListItems?: RadioButtonListItem[]
    onSelectedItem;
    radioOptionsStyle?: CSSProperties;
    radioOptionStyle?: CSSProperties;
    radioStyle?: CSSProperties;
    radioLabelStyle?: CSSProperties;
    selected?: string;
}

const RadioButtonList: React.FC<RadioButtonListProps> = (props) => {
    const [selected, setSelected] = React.useState<undefined | string>(props.selected??undefined);

    const selectOption = (item: RadioButtonListItem) => {
      if (!(item.enable === false)) {
        setSelected(item.id);
        props.onSelectedItem(item.id);
      }
    }

    const renderRadioButton = (item: RadioButtonListItem) => {
      let radioStyles: IRadioButtonProps = {fillColor: '#FFFFFF00', strokeColor: '#a5a5a5'};
      if (item.enable === false) radioStyles = {fillColor: '#bdbdbd80', strokeColor: '#a5a5a5', internalRadius: "8.25"}
      else if (item.id === selected) radioStyles = {fillColor: undefined, strokeColor: undefined}
      return <RadioButtonIcon {...radioStyles} />
    }

    React.useEffect(() => {
      if (props.selected === undefined) setSelected(undefined);
    }, [props.selected])

    function renderRadioItem(item: RadioButtonListItem) {
        return (
            <RadioOption key={item.id} style={props.radioOptionStyle}>
                <ButtonRadioContainer
                  style={props.radioStyle}
                  onClick={() => selectOption(item)}
                >
                  {renderRadioButton(item)}
                </ButtonRadioContainer>
                <LabelRadio style={props.radioLabelStyle} htmlFor={(item.enable || item.enable===undefined)?item.id:undefined} enabled={item.enable}> {item.name}</LabelRadio>
                <LabelMessage enabled={item.enable}> {item.itemMessage}</LabelMessage>
            </RadioOption>
        )
    }

    return (
      <RadioOptions style={props.radioOptionsStyle}>
          {
              props.RadioButtonListItems?.map((item) => renderRadioItem(item))
          }
      </RadioOptions>
    );
}

export default RadioButtonList;
